import type { HelpFile } from '../../types/help'
import { ReportDefinitionEditTestIds } from '../../../testids/ReportDefinitionEditTestIds'

export const reportDefinitionEditHelp: HelpFile = {
  docPage: '/docs/reporting/definitions',
  texts: {
    [ReportDefinitionEditTestIds.reportDefinitionEditPage]:
      'Report-Definition bearbeiten — Name, Beschreibung und die Abfrage des Reports.',
    [ReportDefinitionEditTestIds.inputReportName]:
      'Anzeigename im Katalog.',
    [ReportDefinitionEditTestIds.inputReportDescription]:
      'Zweck, Zielgruppe und wichtige Spalten des Reports.',
    [ReportDefinitionEditTestIds.btnSaveReport]: null,
    [ReportDefinitionEditTestIds.hintSaveLink]:
      'Nach dem Speichern — Report öffnen oder weiter bearbeiten.',
  },
}
